module.exports = __webpack_public_path__ + "img/h1.86cee71d.svg";